/* 本地分页的所有方法 */
import { getCgiDefaultParamsValue } from "../../common/schemaUtil";
import { METHOD_TYPES } from "../../stateCommon/consts";
import { getObjectJSONString } from "../utils/code";
import { invokeAndLogDebugCode, listCountDebugCode } from "./common";
import { initMethodConfig } from "./init";
export function generateLocalListInit(_options) {
  const code = `
    async ( ) => {
    
      // 设置初始值
      source.page =  1;
      source.size =  20;
    
      // filter格式 [ { k:'id',o:'=',v:'100068' } ]
      source.filter = [];
    
      // sort格式 [ { k:'id',o:'asc'},{ k:'no',o:'desc'} ] 
      // o:排序类型 asc(正序) desc(倒序)
      source.sort = [];
    
      // 调用getAllData方法获取全部数据
      await source.$methods.getAllData();
      // 进行第一次分页
      await source.$methods.list();
    }
    `.trim();
  return {
    ...initMethodConfig,
    type: METHOD_TYPES.code,
    code,
    debugCode: listCountDebugCode
  };
}
export function generateLocalListGetAllData(options) {
  const {
    collection,
    isHttp
  } = options;
  let code = '';
  const listPath = options.getProtocolPath('list', 'LIST');
  const {
    codeString,
    messageString
  } = options.getStringOfCodeMessage('list');
  const setDataCode = `
  // 处理list接口的返回结果
  if (${codeString} === 0) {
    source.allData = body${listPath};
    source.total = body${listPath}.length;
  } else {
    $tips.error({
      content: ${messageString}
    })
  } 

  return body;
`;
  if (isHttp) {
    var _collection$cgiInfo;
    const res = getCgiDefaultParamsValue(collection, 'list');
    if (((_collection$cgiInfo = collection.cgiInfo) === null || _collection$cgiInfo === void 0 || (_collection$cgiInfo = _collection$cgiInfo.list) === null || _collection$cgiInfo === void 0 ? void 0 : _collection$cgiInfo.type) === 'get') {
      delete res.body;
    }
    code = `
    async ( ) => {
      // 调用list接口获取所有数据
      const { body } = await source.$requests.list(${getObjectJSONString(res)});
      ${setDataCode}
    }
    `.trim();
  } else {
    code = `
    async () =>{
      // 调用list接口获取所有数据
      const { body } = await source.$requests.list({
          query:{
            size:'total'
          }
      });
      ${setDataCode}
    }
    `;
  }
  return {
    id: 'getAllData',
    title: '获取全部数据',
    autoCatch: true,
    loading: true,
    type: METHOD_TYPES.code,
    code,
    debugCode: invokeAndLogDebugCode
  };
}
export function generateLocalListList(options) {
  const {
    isHttp,
    collection
  } = options;
  let dateKeys = ['date'];
  const {
    entity
  } = collection;
  if (!isHttp) {
    var _entity$fields;
    const list = [10, 11, 12];
    dateKeys = (entity === null || entity === void 0 || (_entity$fields = entity.fields) === null || _entity$fields === void 0 ? void 0 : _entity$fields.filter(item => {
      var _item$ui;
      return list.includes((_item$ui = item.ui) === null || _item$ui === void 0 ? void 0 : _item$ui.settings.type);
    }).map(item => String(item.id))) || [];
  } else {
    var _entity$fields2;
    const {
      entity
    } = collection;
    const likeDateKeys = ['time', 'date'];
    dateKeys = (entity === null || entity === void 0 || (_entity$fields2 = entity.fields) === null || _entity$fields2 === void 0 ? void 0 : _entity$fields2.filter(item => {
      const id = String(item.id).toLowerCase();
      return likeDateKeys.some(key => key === id || id.endsWith(key));
    }).map(item => String(item.id))) || [];
  }
  const code = `
  async () => {
    const { page, size, allData } = source;
  
    // 过滤数据
    const filterData = $utils.filterData(allData, source.filter, {
      // 'and':并操作；'or':或操作
      type: 'and',
      // false则不区分大小写
      caseSensitive: false,
      // true:1不等于'1'；false:则1等于'1'
      strict: false,
    });
  
    // 排序
    const sortData = $utils.orderBy(
      filterData,
      source.sort.map(item => {
        // 字符串的时间字段需要转成Date对象
        return ${JSON.stringify(dateKeys || [])}.includes(item.k) ? (obj) => new Date(obj[item.k]) : item.k
      }),
      source.sort.map(item => item.o));
  
  
    // 获取分页后的数据
    const begin = (page - 1) * size;
    const end = begin + size;
    const pageData = sortData.slice(begin, end);
  
    source.listData = pageData;
    source.total = filterData.length;
  
    return pageData;
  }
        `.trim();
  return {
    id: 'list',
    title: '设置分页数据',
    autoCatch: true,
    loading: true,
    type: METHOD_TYPES.code,
    code,
    debugCode: invokeAndLogDebugCode
  };
}
//# sourceMappingURL=localList.js.map
